import React from 'react';
import styled from 'styled-components';
import { Text, Flex, Box } from '../neta';
import Img from 'gatsby-image';

const AuthorImg = styled(Img)`
  border-radius: 50%;
  width: 5rem;
  height: 5rem;
`;

export default class AuthorAttribution extends React.Component {
  render() {
    const { author, date, timeToRead } = this.props;
    if (author === undefined) return null;
    return (
      <Flex alignItems="center">
        {author.image && (
          <Box pr={5}>
            <AuthorImg
              data-pin-nopin="true"
              sizes={author.image.sizes}
              alt={author.name}
            />
          </Box>
        )}
        <Box width={[2 / 3, 3 / 4, 2 / 3]} pl={[4, 2, 2]} pr={[0, 4]}>
          <Text.body style={{ textTransform: 'uppercase' }}>{author.name}</Text.body>
          <br />
          <Text.caption color="grayscale.stone">
            {date}
            {timeToRead ? <Text> | {timeToRead}</Text> : null}
          </Text.caption>
        </Box>
      </Flex>
    );
  }
}
